/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Line, Circle, Polyline, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Dog(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Line
        x1={128}
        y1={192}
        x2={128}
        y2={216}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Circle cx={92} cy={136} r={16} />
      <Circle cx={164} cy={136} r={16} />
      <Polyline
        points="144 176 128 192 112 176"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M152,48l55.76169-13.94042a8,8,0,0,1,9.80326,6.28683l16.41859,87.56583c1.54221,8.22509-8.98332,12.99712-14.15352,6.41688Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M104,48,48.23831,34.05958A8,8,0,0,0,38.435,40.34641L22.01646,127.91224c-1.54221,8.22509,8.98332,12.99712,14.15352,6.41688Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Line
        x1={104}
        y1={48}
        x2={152}
        y2={48}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M208,119.27273V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.27273"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default Dog;
